import { MultipleChoiceItem } from "./MultipleChoiceItem";

export default MultipleChoiceItem;
